import { PostThemeElementsTheme } from '@nucleus/post-theme-elements';
import React from 'react';
import { ThemeProvider } from 'styled-components';

interface Props {
  children?: React.ReactNode;
  theme: PostThemeElementsTheme;
}

export const PostThemeElementsThemeProvider = (props: Props): JSX.Element => {
  return <ThemeProvider theme={{ _postThemeElements: props.theme }}>{props.children}</ThemeProvider>;
};
